import React, { Component } from 'react';
import './Activity.scss'

class Activity extends Component {

    render() {
        return (
            <div className="wtm-activity">
                <h1>ACTIVITY</h1>

                <ul className="list">
                    <li className="card-group">
                        <div className="card">
                            <h3 className="major">
                                WTM에서는 의사소통의 다양성을 존중하고 소속, 성별, 외모, 나이에 따른 차별을 금지하며, 종교 및 정치적 성향들을 띄는 발언 또한 금지합니다.
                            </h3>
                        </div>
                    </li>
                    <li className="card-group">
                        <div className="card">
                            <h3 className="major">
                                스피드 네트워킹
                            </h3>
                            <p className="minor">
                                업계의 어떤 여성들이 함께 일하고 있는지 더 만나고 더 알고 싶으시죠?
                                컨퍼런스에 와서 재밌는 이야기를 듣고나서 더 많은 것을 나눌 친구들을 만나보세요! 정해진 시간동안 빠르게 마음 맞는 친구들을 만날 수 있도록 도와드릴게요
                            </p>
                        </div>
                        <div className="card">
                            <h3 className="major">
                                스터디그룹 메이킹
                            </h3>
                            <p className="minor">
                                실력을 향상 시키는 데에는 꾸준한 스터디만큼 좋은 것이 없죠! 여성 멤버로만 구성된 스터디를진 행해보는 것은 어떠세요? 원하는 스터디를 알려주시면 스터디원을 구성해드릴게요!
                            </p>
                        </div>
                    </li>
                </ul>
            </div>
        );
    }
}

export default Activity;
